import styled from 'styled-components';
import Button from 'antd/lib/button';

export const StyledMapButton = styled(Button)`
  margin: 10px;
`;
